import React from "react";
import searchIcon from "./../../assets/search-interface-symbol.png";
const FaqSearch = () => {
  return (
    <>
      <form className="d-flex">
        <div className="input-group mb-3">
          <span
            className="input-group-text bg-white border-dark p-2"
            id="basic-addon1"
          >
            <img src={searchIcon} alt="search" className="mx-2" width={18} />
          </span>
          <input
            type="text"
            className="form-control border-start-0 border-dark no-outline p-2 custom-placeholder fst-italic fw-light"
            placeholder="How can we assits you ?"
            aria-label="search"
            aria-describedby="basic-addon1"
          />
        </div>
      </form>
    </>
  );
};

export default FaqSearch;
